// extracted by mini-css-extract-plugin
module.exports = {"labelContainer":"field_labelContainer__3V4wt"};